import { useState, useMemo, useEffect, useRef } from "react";
import countryList from "react-select-country-list";
import Select from "react-select";

import {
  Text,
  Center,
  Box,
  FormControl,
  FormLabel,
  Input,
  Flex,
  VStack,
  Textarea,
} from "@chakra-ui/react";
import "../collaboration-signup/collaboration-registration.css";
import ScrollAnimation from "react-animate-on-scroll";
import emailjs from "@emailjs/browser";

export default function CollabRegistration() {
  var [input, setInput] = useState({
    user_name: "",
    user_email: "",
    user_comment: "",
    user_designation: "",
    user_country: "",
    user_affiliation: "",
  });
  const form = useRef();
  const inputRef = useRef(null);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  var [errors, setErrors] = useState({});
  const handleChange = (event) => {
    input[event.target.name] = event.target.value;
    setInput(input);
  };
  //code for country selection
  const options = useMemo(() => countryList().getData(), []);

  //code for designation options
  const designationOption = [
    { value: "trainee", label: "Trainee" },
    { value: "pediatric-surgeon", label: "Pediatric Surgeon" },
    { value: "pediatric-urologist", label: "Pediatric Urologist" },
    { value: "adult-urologist", label: "Adult Urologist" },
  ];

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validate()) {
      let userID = "user_fXtNu4o4WtM344HfoZi1b";
      emailjs
        .send(
          "contact_service",
          "contact_form",
          {
            to_name: "Dr. Tariq",
            message: `Designation: ${input.user_designation}, 
            Affiliation: ${input.user_affiliation},
            Country: ${input.user_country}, 
            Collboration Reason: ${input.user_comment}`,
            from_email: input.user_email,
            from_name: input.user_name,
          },
          userID
        )
        .then(
          (result) => {
            alert("Your application has been submited");
          },
          (error) => {
            alert(error.text);
          }
        );

      Array.from(document.querySelectorAll("input")).forEach(
        (input) => (input.value = "")
      );
      document.querySelector("textarea").value = "";
    }
  };

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  function validate() {
    let checkInput = input;
    let errors = {};
    let isValid = true;

    if (checkInput["user_name"].length < 8) {
      isValid = false;
      errors["name"] = "username should be minimum 8 characters long.";
    }

    if (typeof checkInput["user_email"] !== "undefined") {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(input["user_email"])) {
        isValid = false;
        errors["email"] = "Please enter valid email address.";
      }
    }
    setErrors(errors);
    return isValid;
  }

  return (
    <Box
      id='collab-registration'
      display='flex'
      flexDir='column'
      justifyContent='center'
      className='collab-registration'
    >
      <ScrollAnimation animateIn='fadeIn'>
        <Box
          width={{
            base: "85%",
            md: "60%",
            xl: "50%",
          }}
          border='10px'
          boxShadow='md'
          p={5}
          rounded='md'
          bg='rgba(31, 159, 181, 0.6)'
          mx='auto'
        >
          <Flex flexDir='column' zIndex={0}>
            <VStack>
              <Box>
                <Center>
                  <Text
                    color='white'
                    fontSize={{ base: "xl", md: "3xl", lg: "4xl" }}
                    fontWeight={700}
                  >
                    Sign Up For Collaboration
                  </Text>
                </Center>
              </Box>
            </VStack>
            <form onSubmit={handleSubmit} ref={form}>
              <FormControl id='name' isRequired>
                <FormLabel color='white' fontSize='18px'>
                  Name
                </FormLabel>
                <Input
                  type='text'
                  placeholder='type your name here'
                  name='user_name'
                  _focus={{
                    zIndex: "0",
                    borderColor: "#3182ce",
                  }}
                  color='white'
                  onChange={handleChange}
                  value={input.name}
                  ref={inputRef}
                />
                <Text color='red' fontSize='18px' fontWeight={700}>
                  {errors.name}
                </Text>
              </FormControl>
              <FormControl id='designation' isRequired>
                <FormLabel color='white' fontSize='18px'>
                  Designation
                </FormLabel>
                <Select
                  defaultValue={selectedDesignation}
                  id='designation'
                  color='white'
                  fontSize='18px'
                  options={designationOption}
                  name='user_designation'
                  onChange={(selectedDesignation) => {
                    setSelectedDesignation(selectedDesignation);
                    setInput({
                      ...input,
                      user_designation: selectedDesignation.value,
                    });
                  }}
                />
              </FormControl>

              <FormControl id='affiliation' isRequired>
                <FormLabel color='white' fontSize='18px'>
                  Affiliation
                </FormLabel>
                <Input
                  type='text'
                  placeholder='affiliation'
                  name='user_affiliation'
                  onChange={handleChange}
                  value={input.affiliation}
                  _focus={{
                    zIndex: "0",
                    borderColor: "#3182ce",
                  }}
                  color='white'
                />
              </FormControl>

              <FormControl id='country' isRequired>
                <FormLabel color='white' fontSize='18px'>
                  Country
                </FormLabel>
                <Select
                  defaultValue={selectedCountry}
                  options={options}
                  onChange={(selectedCountry) => {
                    setSelectedCountry(selectedCountry);
                    setInput({ ...input, user_country: selectedCountry.label });
                  }}
                  name='user_country'
                  _focus={{
                    zIndex: "0",
                    borderColor: "#3182ce",
                  }}
                />
              </FormControl>

              <FormControl id='email' isRequired>
                <FormLabel color='white' fontSize='18px'>
                  Email address
                </FormLabel>
                <Input
                  type='email'
                  placeholder='type your email here'
                  name='user_email'
                  _focus={{
                    zIndex: "0",
                    borderColor: "#3182ce",
                  }}
                  onChange={handleChange}
                  value={input.email}
                  color='white'
                />
                <Text color='red' fontSize='18px' fontWeight={700}>
                  {errors.email}
                </Text>
              </FormControl>

              <FormControl id='comment' isRequired>
                <FormLabel color='white' fontSize='18px'>
                  How do you want to collaborate with us?
                </FormLabel>
                <Textarea
                  placeholder='please tell us how do you want to collaborate with us'
                  name='user_comment'
                  onChange={handleChange}
                  value={input.comment}
                  minLength='150'
                  _focus={{
                    zIndex: "0",
                    borderColor: "#3182ce",
                  }}
                  color='white'
                  size='md'
                />
              </FormControl>

              <Box
                as='button'
                mt='2%'
                p={2}
                color='white'
                fontWeight='bold'
                borderRadius='md'
                bgGradient='linear(to-r, teal.500,green.500)'
                _hover={{
                  bgGradient: "linear(to-r, red.500, yellow.500)",
                }}
                type='submit'
                value='Submit'
              >
                Submit
              </Box>
            </form>
          </Flex>
        </Box>
      </ScrollAnimation>
    </Box>
  );
}
